module BrowserNative

open System
open System.Text.RegularExpressions

open Browser
open Browser.Types

open Fable.Core
open Fable.Core.JsInterop

let private exportOptions =
    {|
        id = "export"
        suggestedName = sprintf "so-many-minutes-%s.json" (DateTime.Now.ToString("o"))
        types = [|
            {|
                description = "Json File"
                accept = createObj [
                    "application/json" ==> [| ".json" |]
                ]
            |}
        |]
    |}

let saveExport data =
    let showSaveFilePicker options : JS.Promise<obj> = emitJsExpr options "window.showSaveFilePicker($0)"
    let createWriteable handle : JS.Promise<obj> = emitJsExpr handle "$0.createWritable()"
    let write writeable contents : JS.Promise<unit> = emitJsExpr (writeable, contents) "$0.write($1)"
    let close writeable : JS.Promise<unit> = emitJsExpr writeable "$0.close()"
    
    promise {
        let! handle = showSaveFilePicker exportOptions
        let! writeable = createWriteable handle
        do! write writeable data
        do! close writeable
    }

let loadExport () =
    let showOpenFilePicker options : JS.Promise<obj array> = emitJsExpr options "window.showOpenFilePicker($0)"
    let getFile handle : JS.Promise<obj> = emitJsExpr handle "$0.getFile()"
    let readText file : JS.Promise<string> = emitJsExpr file "$0.text()"

    promise {
        try
            let! handles = showOpenFilePicker exportOptions
            if handles.Length > 0 then
                let handle = handles[0]
                let! file = getFile handle
                let! text = readText file
                return Some text
            else
                return None
        with _ ->
            return None
    }

module Capabilities =
    type URLSearchParams with
        [<Emit("$0.forEach($1)")>]
        member _.forEach(f: (string -> string -> URLSearchParams -> unit)) = jsNative<unit>

    //These convolutions are for the node based test runner, I could stand up a
    //fake DOM for this, but it's so meagre, its easier to just skip over it.
    let private globalThis: obj = emitJsExpr () "globalThis"

    let hasTouchscreen =
        jsIn "ontouchstart" globalThis && navigator.maxTouchPoints > 0

    let isIOS =
        if jsIn "navigator" globalThis then
            if Regex.IsMatch(navigator.userAgent, "iPhone|iPad|iPod") then true
            else
                //slightly awkward test for iPad, which no longer identifies itself
                //in the user agent string, alas, harkens back to the bad old days
                navigator.platform = "MacIntel" && navigator.maxTouchPoints > 0
        else
            false

    let queryParams () =
        let mutable result = Map.empty

        if jsIn "location" globalThis then
            let url = URL.Create(window.location.href)
    
            url.searchParams.forEach(fun value key _ ->
                result <- result |> Map.add key value
            )

        result

module Page =
    let clearQuery () =
        let url = URL.Create(window.location.href)
        url.search <- ""

        history.replaceState(null, "", url.toString());
        window.location.reload();
